/**
 * @description Перевести первый символ строки в верхний регистр.
 * @param {string} word Строка.
 * @returns {string}
 */
const capitalize = (word) => word.charAt(0).toUpperCase() + word.slice(1);

/**
 * @description Локаль даты.
 * @type {string}
 */
const dateLocale = 'ru-ru';

/**
 * @description Шаблон маски времени.
 * @type {string}
 */
const timeMask = '##:##';

/**
 * @description Шаблон маски времени.
 * @type {string}
 */
const timePattern = '^([01][0-9]|2[0-3]):[0-5][0-9]$';

/**
 * @description Заполнитель поля ввода даты.
 * @type {string}
 */
const timePlaceholder = 'чч:мм';

/**
 * @description Получить строку ISO даты по объекту даты.
 * @param {Date} date Дата.
 * @returns {string}
 */
export const getISODateStringByDate = (date) => date.toISOString().split('T')[0];

/**
 * @description Получить строку ISO даты в локальном времени по объекту даты.
 * @param {Date} date Дата.
 * @returns {string}
 */
export const getLocalISODateStringByDate = (date) => {
  const pad = (num, length = 2) => String(num).padStart(length, '0');
  const year = date.getFullYear();
  const month = pad(date.getMonth() + 1);
  const day = pad(date.getDate());
  return `${year}-${month}-${day}`;
};

/**
 * @description Получить строку ISO даты по строке.
 * @param {string} date Дата.
 * @returns {string}
 */
export const getISODateStringByString = (date) => {
  const matches = date.match(
    '^(?<day>[0-9]{2})[\\/.](?<month>[0-9]{2})[\\/.](?<year>[0-9]{4})$',
  );
  if (matches && matches.groups) {
    return [
      matches.groups.year,
      matches.groups.month,
      matches.groups.day,
    ].join('-');
  }
  return '';
};

/**
 * @description Сопоставить время.
 * @param {any} unmatched Обходное значение.
 * @returns {function(string): string|any}
 */
export const matchTime = (unmatched) => {
  const pattern = new RegExp(timePattern);
  return (candidate) => (pattern.test(candidate) ? candidate : unmatched);
};

/**
 * @description Примесь даты.
 * @type {any}
 */
export default {
  dateLocale,
  timeMask,
  timePattern,
  timePlaceholder,
  methods: {
    /**
     * @description Получить стандартный формат.
     * @param {(Date|string)} candidate Исходная дата.
     * @param {boolean} inLocalTimeZone В текущем часовом поясе.
     * @returns {string}
     */
    formatDateToISO(candidate, inLocalTimeZone = false) {
      if (candidate instanceof Date) {
        if (inLocalTimeZone) {
          return getLocalISODateStringByDate(candidate);
        }
        return getISODateStringByDate(candidate);
      }
      if (typeof candidate === 'string') {
        return getISODateStringByString(candidate);
      }
      return '';
    },
    /**
     * @description Получить короткий заголовок дня недели.
     * @param {string} isoDate Дата.
     * @returns {string}
     */
    getWeekdayShortTitle(isoDate) {
      const options = { weekday: 'short' };
      return (new Date(isoDate))
        .toLocaleDateString(dateLocale, options)
        .toUpperCase();
    },
    /**
     * @description Получить заголовок года и месяца.
     * @param {string} isoDate Дата.
     * @returns {string}
     */
    getYearAndMonthTitle(isoDate) {
      const date = new Date(isoDate);
      const month = date.toLocaleString(dateLocale, { month: 'long' });
      const year = date.getFullYear();
      return `${capitalize(month)} ${year}`;
    },
    /**
     * @description Получить день и название месяца.
     * @param {string} isoDate Дата.
     * @returns {string}
     */
    getFullDate(isoDate) {
      const options = {
        day: 'numeric',
        month: 'long',
      };
      const date = new Date(isoDate);
      const formatted = date.toLocaleDateString('ru-RU', options);
      return `${formatted} ${date.getFullYear()}`;
    },
    getShortDate(isoDate) {
      const date = new Date(isoDate);
      const day = date.getDate().toString().padStart(2, '0');
      const month = (date.getMonth() + 1).toString().padStart(2, '0');
      const year = date.getFullYear().toString().slice(2);
      return `${day}.${month}.${year}`;
    },
  },
};
